import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "../../../../../Shared/Glyphicon/Glyphicon";
import Cell from "source/app/presentation/MainPanel/Dreams/Cell/Cell";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function RepeatingIcon({ isRepeating }: { isRepeating: boolean }) {
    if (!isRepeating) {
        return null;
    }

    return (
        <Cell
            classes={StyleClass(`calendarEventRepeatingIcon`, {
                position: `relative`,
                top: `2px`,
            })}
        >
            <Glyphicon icon={EGlyphicon.refresh} />
        </Cell>
    );
}
